// Select the node that will be observed for mutations
const targetNode = document.getElementById("shopify-block-judge_me_reviews_preview_badge_8may7E");

if (targetNode) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        console.log('Mutation detected');
        const childNode = targetNode.querySelector('.jdgm-prev-badge');
        const customReview = document.getElementsByClassName("custom-review")[0]; // Access the first element in the collection
        
        if (childNode && customReview) {
            const averageRating = childNode.getAttribute('data-average-rating');
            const numberOfReviews = childNode.getAttribute('data-number-of-reviews');
            // console.log('the node ', childNode);
            // console.log(`Average Rating: ${averageRating}, Number of Reviews: ${numberOfReviews}`);
            
            const ratingDataElement = customReview.querySelector('.rating-data');
            const countDataElement = customReview.querySelector('.count-data');

            if (ratingDataElement) {
                ratingDataElement.innerHTML = averageRating;
            }

            if (countDataElement) {
                countDataElement.innerHTML = numberOfReviews;
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
} else {
    console.log('Mutation Target node not found');
}
